import { IconWrapper } from '../runtime';
export default IconWrapper('eye', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "8",
      "cy": "7.99976",
      "r": "2",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 3.24976C2.85149 3.24976 1 7.99976 1 7.99976C1 7.99976 2.85149 12.7498 8 12.7498C13.1485 12.7498 15 7.99976 15 7.99976C15 7.99976 13.1485 3.24976 8 3.24976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});